import { API_ERROR_MAP, STRIPE_DECLINE_MESSAGE_GROUPS } from 'types'

// Resolves an API error key or Stripe decline code to a user-facing message.
// API keys are lowercased to match group codes.
const getMessageForErrorKey = (key) => {
  if (!key) return API_ERROR_MAP.UNKNOWN_ERROR

  const declineCode = String(key).toLowerCase()
  const group = STRIPE_DECLINE_MESSAGE_GROUPS.find((declineGroup) =>
    declineGroup.codes.includes(declineCode),
  )

  if (group) return group.message
  if (API_ERROR_MAP[key]) return API_ERROR_MAP[key]
  
  return API_ERROR_MAP.UNKNOWN_ERROR
}

export default getMessageForErrorKey
